import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { CookbookSelectWrapper } from 'src/components/CookbookSelectWrapper/CookbookSelectWrapper';
import { monthlyAvailabilityOptions } from 'src/components/oneCorp/features/MealCredit/common/formFields/Select/AvailableOnSelect/AvailableOnSelect.utils';

export interface AvailableOnSelectProps {
  name: string;
  id: string;
  disabled?: boolean;
}

export function AvailableOnSelect({
  name,
  id,
  disabled,
}: AvailableOnSelectProps): JSX.Element {
  const { control, errors } = useFormContext();

  return (
    <CookbookSelectWrapper
      label="Orders can be received"
      name={name}
      id={id}
      options={monthlyAvailabilityOptions}
      error={errors[name]}
      control={control}
      disabled={disabled}
      blockWidth
    />
  );
}
